import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';
import { UserInfo } from '../userinfo';
import { TokenResponse } from '@openid/appauth';
import { Router } from '@angular/router';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
    public userInfo: UserInfo | null;
    public authorized: boolean;

    constructor(public router: Router, private authorizationService: AuthorizationService) {
    }

    ngOnInit() {
        this.authorizationService.userInfos().subscribe((userInfo: UserInfo) => {
            this.userInfo = userInfo;
        });
        this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
            this.authorized = tokenResponse != null;
        });
    }

    Authorize() {
        this.authorizationService.authorize();
        this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
            this.authorized = tokenResponse != null;
        });
        if (this.authorized) {
            this.router.navigate(['/home/AppCatalog']);
        }
    }

    // hideshow()
    // {
    //     debugger;    
    //     document.getElementById("sideNavbar").classList.toggle('active')    
    // }
}